<template>
  <div class="container">
    <!-- <div class="textBox">
      <div
        v-for="(item, index) in Number(detail)"
        :key="index"
        class="imgBox"
      >
        <img :src="`https://ixy.xydatacenter.cn:3721/sga/govmm/register/${type}/${branchId}/${index}.jpg`" alt="">
      </div>  
    </div> -->
    <div>
      <div id="pdf">
        <div id="demo"></div>
      </div>
    </div>
    <div class="voteBox">
      <div class="title">
        <div class="line">
        </div>
        <p>我要投票</p>
        <div class="line">
        </div>
      </div>
      <div class="buttonBox">
        <span
          v-for="(level, i) in levelList"
          :key="i"
          @click="doSelected(i + 1)"
          :class="{
            default: true,
            highlight: level.isSelected && ImgIsShow,
            graylight: !level.isSelected && ImgIsShow,
          }"
          >{{ level.codeValue }}
        </span>
      </div>
      <div class="picBox" v-if="ImgIsShow">
        <img src="../assets/img/onlineAssessment/finished.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { checkAJB } from "@/utils/JSBridge";
import Pdfh5 from "pdfh5"
import "pdfh5/css/pdfh5.css"
export default {
  data() {
    return {
      detail: "",
      branchId: "",
      type: "",
      pdfh5: null,
      ImgIsShow: false,
      levelListIndex: 0,
      levelList: [
        {
          isSelected: false,
          codeValue: "满意",
        },
        {
          isSelected: false,
          codeValue: "较满意",
        },
        {
          isSelected: false,
          codeValue: "不满意",
        },
        {
          isSelected: false,
          codeValue: "不了解",
        },
      ],
    };
  },
  methods: {
    initPdf() {
      console.log(this.branchId, 'branchID')
      this.pdfh5 = new Pdfh5("#demo",{
        pdfurl:`./pdf/${this.branchId}.pdf`,
        pageNum:false
      })
    },
    doSelected(vote) {
      this.levelListIndex = vote;
      this.requestWX({
        url: "/sga/SGAEpidemic/onlineComment/vote",
        type: "post",
        params: {
          userId: this.$route.query.userId, //用户ID
          branchId: this.$route.query.branchId, //机构ID
          vote: vote, //1-满意，2-较满意，3-不满意，4-不了解
          batch: "second",
        },
      })
        .then((res) => {
          console.log("投票结果", res);
          if (res.respCode == "00000000") {
            this.$toast("投票成功");
            this.ImgIsShow = true;
            this.levelList[this.levelListIndex - 1].isSelected = true;
          } else {
            this.$toast("投票失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    levelList: {
      handler(newVal) {
        this.levelList = newVal;
      },
      deep: true,
    },
  },
  mounted() {
    this.detail = this.$route.query.detail;
    this.branchId = this.$route.query.branchId
    this.type = this.$route.query.type;
    if (this.$route.query.vote) {
      this.ImgIsShow = true;
      this.levelList[this.$route.query.vote - 1].isSelected = true;
    }
    this.initPdf()
    // console.log(this.$route.query, "this.$route.query");
  },
};
</script>
<style scoped>
html, body {
  overflow: hidden;
}
#pdf {
  width: 100%;
  height: calc(100vh - 2.5rem);
}
.pdfjs {
  background: #f9f9f9;
}
.pdfjs .backTop {
  z-index: 99999999;
  bottom: 4rem;
}
.pdfjs .pdfViewer {
  padding: 0.1rem 0.16rem;
}
img {
  pointer-events: none;
}
* {
  -weblit-touch-call:none;
  -weblit-user-select:none;
  -moz-user-select: none;
  -ms-user-select:none;
  user-select:none
}
</style>
<style lang="less" scoped>
.container {
  // position: fixed;
  // top: 0;
  // right: 0;
  // bottom: 0;
  // left: 0;
  height: 100vh;
  // padding: 0.24rem;
  user-select: none;
  box-sizing: border-box;
  overflow: hidden;
  .textBox {
    width: 100%;
    // height: 4.3rem;
    background: #ffffff;
    border-radius: 5px;
    padding: 0.5rem;
    .text {
      font-size: 0.3rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 0.5rem;
    }
    .imgBox {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
  .voteBox {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    // line-height: 0.6rem;
    background: #ffffff;
    padding: 0.5rem;
    .buttonBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 5px;
      color: #1494eb;
      // padding: 0 0.2rem;
    }
    .picBox {
      position: absolute;
      right: 0.02rem;
      top: 0.2rem;
      img {
        width: 1.8rem;
      }
    }
  }
}
.title {
  height: 0.4rem;
  line-height: 0.4rem;
  margin-bottom: 0.35rem;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    font-size: 0.4rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .line {
    width: 20%;
    height: .02rem;
    background: #666;
    margin: 0 10px;
  }
}
.highlight {
  background-color: rgba(20, 145, 235, 0.5) !important;
  border: 1px solid transparent !important;
  color: #fff !important;
}
.graylight {
  background-color: rgba(188, 188, 188, 0.5) !important;
  border: 1px solid transparent !important;
  color: #fff !important;
}
.btnclass {
  color: #1491eb !important;
  background-color: #fff !important;
  border: 1px solid #1491eb !important;
}
.default {
  border-radius: 0.66rem;
  font-size: 0.4rem;
  text-align: center;
  display: block;
  // padding: 0.16rem 0.36rem;
  width: 1.8rem;
  height: 0.8rem;
  line-height: 0.8rem;
  box-sizing: border-box;
  border: 1px solid #1491eb;
  color: #1491eb;
}
</style>